import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserInactiveService {
  private redirectedByInterceptor = false;

  setRedirectedByInterceptor(): void {
    this.redirectedByInterceptor = true;
  }

  wasRedirectedByInterceptor(): boolean {
    const result = this.redirectedByInterceptor;
    this.redirectedByInterceptor = false;
    return result;
  }
}
